import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IKRA_LOGO, CONTACT } from "@/data/content";
import { LEGAL } from "@/data/legal";
import Footer from "@/components/ikra/Footer";

export default function LegalPage({ kind }) {
  const doc = LEGAL[kind];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} · IKRA Marketing & Sales`;
  }, [doc.title]);

  return (
    <div data-testid={`legal-page-${kind}`} className="bg-[var(--ikra-bg)] text-[var(--ikra-ink)] font-body min-h-screen">
      <header className="border-b border-[var(--ikra-line)]">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-3">
            <img src={IKRA_LOGO} alt="Ikra" className="h-11 w-11 object-contain" style={{ mixBlendMode: "screen" }} />
            <span className="font-display font-semibold text-lg tracking-tight">IKRA Marketing &amp; Sales</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-[var(--ikra-ink)]/75 hover:text-[var(--ikra-gold)] transition-colors"
          >
            <ArrowLeft size={16} /> Wróć na stronę główną
          </Link>
        </div>
      </header>

      <main className="max-w-[880px] mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="text-xs uppercase tracking-[0.24em] text-[var(--ikra-gold)] flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-[var(--ikra-gold-bright)]" />
          {doc.kicker}
        </div>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight uppercase">
          {doc.title}
        </h1>
        <p className="mt-6 text-sm text-[var(--ikra-muted)]">Obowiązuje od {doc.updated}</p>

        <div className="mt-14 space-y-12">
          {doc.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-lg md:text-xl text-[var(--ikra-ink)] tracking-tight">
                {i + 1}. {s.title}
              </h2>
              <span className="mt-3 inline-block h-px w-10 bg-[var(--ikra-gold)]" />
              <div className="mt-5 space-y-3 text-[15px] text-[var(--ikra-muted)] leading-relaxed">
                {s.paragraphs.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
                {s.list && (
                  <ul className="space-y-2 pl-1">
                    {s.list.map((li, j) => (
                      <li key={j} className="flex items-start gap-3">
                        <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[var(--ikra-gold-bright)] shrink-0" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 p-6 rounded-2xl border border-[var(--ikra-line)] bg-[var(--ikra-bg-alt)] text-sm text-[var(--ikra-muted)]">
          Pytania dotyczące tego dokumentu: {" "}
          <a href={`mailto:${CONTACT.email}`} className="text-[var(--ikra-gold)] ikra-link">
            {CONTACT.email}
          </a>
          , {CONTACT.phone}, {CONTACT.address}.
        </div>
      </main>

      <Footer />
    </div>
  );
}
